<template>
	<div>
		<ValidationObserver ref="formModalValidate">
			<b-row>
				<b-col cols="12" md="4">
					<ValidationProvider name="faculty_code" rules="" v-slot="{valid, errors}">
						<b-form-group :label="$t('faculty')">
							<faculty-selectbox v-model="formData.faculty_code"
							                   :validate-error="errors[0]"/>
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12" md="4">
					<ValidationProvider name="department_code" rules="" v-slot="{valid, errors}">
						<b-form-group :label="$t('department')">
							<department-selectbox v-model="formData.department_code"
							                      :faculty_code="formData.faculty_code"
							                      :validate-error="errors[0]"/>
						</b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12" md="4">
					<ValidationProvider name="program_code" rules="" v-slot="{valid, errors}">
						<b-form-group :label="$t('program')">
							<program-selectbox v-model="formData.program_code"
							                   :faculty_code="formData.faculty_code"
							                   :department_code="formData.department_code"
							                   :validate-error="errors[0]"/>
						</b-form-group>
					</ValidationProvider>
				</b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="registration_semester_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('registration_semester')">
                            <semesters-selectbox
                                v-model="formData.registration_semester_id"
                                :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                  <ValidationProvider name="student_number" rules="" v-slot="{valid, errors}">
                    <b-form-group :label="$t('student_number')">
                      <b-form-input
                          v-model="formData.student_number"
                          :state="errors[0] ? false:null">
                      </b-form-input>
                      <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                  <ValidationProvider name="slot_id" rules="" v-slot="{valid, errors}">
                    <b-form-group :label="$t('slot_id')">
                      <b-form-input type="text" v-model="formData.slot_id"
                                    :state="errors[0] ? false : null"/>
                      <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                  <ValidationProvider name="slot_type" rules="" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('slot_type')">
                      <slot-type-selectbox v-model="formData.slot_type" :validateError="errors[0]" />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                  <ValidationProvider name="course_code" rules="" v-slot="{valid, errors}">
                    <b-form-group :label="$t('course_code')">
                      <b-form-input type="text" v-model="formData.course_code"
                                    :state="errors[0] ? false : null"/>
                      <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                  <ValidationProvider name="semester" rules="" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('semester')">
                      <semesters-selectbox v-model="formData.semester_id"
                                           :validate-error="errors[0]"></semesters-selectbox>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                  <ValidationProvider name="pool_id" rules=""
                                      v-slot="{ valid, errors }">
                    <b-form-group :label="$t('elective_pools_title')">
                      <elective-pool-selectbox v-model="formData.pool_id" :program-code="formData.program_code"
                                               :type="formData.slot_type" :validateError="errors[0]" />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                  <ValidationProvider name="credit" rules="" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('credit')">
                      <b-form-input type="number" v-model="formData.credit" :state="errors[0] ? false : null" />
                      <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
			</b-row>

			<div class="d-flex justify-content-center mt-2">
				<b-button variant="primary"
				          @click="createForm"
				          :disabled="formLoading">
					{{ $t('save') }}
				</b-button>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
	// Components
	import DepartmentSelectbox from "@/components/interactive-fields/DepartmentSelectbox";
	import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
    import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
    import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
    import SlotTypeSelectbox from "@/components/interactive-fields/SlotTypeSelectbox.vue";
    import ElectivePoolSelectbox from "@/components/interactive-fields/ElectivePoolSelectbox";

    // Services
	import StudentSlotBulkService from "@/services/StudentSlotBulkService";

	// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"

	export default {
		components: {
      SlotTypeSelectbox,
      AcademicYearsSelectbox,
      DepartmentSelectbox,
      FacultySelectbox,
      ProgramSelectbox,
      ElectivePoolSelectbox,
      ValidationProvider,
      ValidationObserver,
		},
		data() {
			return {
				formData: {
					faculty_code: null,
					department_code: null,
					program_code: null,
          registration_semester_id: null,
					student_number: null,
					operation_type: 'insert',

					slot_id: null,
					slot_type: null,
					course_code: null,
					semester: null,
					pool_id: null,
				},
				formLoading: false,
			}
		},
		methods: {
			async createForm() {
                if(this.checkPermission('studentslot_bulkupdate')){
                    const isValid = await this.$refs.formModalValidate.validate();
                    if (isValid) {
                        this.formLoading = true;
                        StudentSlotBulkService.store(this.formData)
                                     .then(response => {
                                         this.$toast.success(this.$t('api.' + response.data.message));
                                         this.$emit('createFormSuccess', true);
                                     })
                                     .catch(e => {
                                         this.showErrors(e, this.$refs.formModalValidate);
                                     })
                                     .finally(() => {
                                         this.formLoading = false
                                     })
                    }
                } else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }
			}
		}
	}
</script>

